import AdminDuplicateDevicesScreen from '../../src/screens/AdminDuplicateDevicesScreen';

export default function AdminDuplicateDevicesRoute() {
  return <AdminDuplicateDevicesScreen />;
}
